
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconTowerEast as ObiBeaconTowerEastElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-tower-east.js';
 
 
 

 
 export const ObiBeaconTowerEast = createComponent({
   react: React,
   tagName: 'obi-beacon-tower-east',
   elementClass: ObiBeaconTowerEastElement,
   events: {
     
   }
  });
 
 